/**
 * Stable internal flag keys used by the navigation registry and app code.
 * These never change when swapping env defaults for LaunchDarkly.
 */
export const FEATURE_FLAG_KEYS = Object.freeze({
    CAD_AVL_SETTINGS: 'cadAvlSettings',
    UI_EARLY_ACCESS_INDICATOR: 'uiEarlyAccessIndicator',
    ENABLE_UNDER_MAINTENANCE: 'enableUnderMaintenance',
    ENABLE_REMOVE_AGENCY_USER: 'enableRemoveAgencyUser',
});

/**
 * Maps internal keys → LaunchDarkly dashboard flag keys.
 * LD integration merges remote values over env defaults using this map.
 */
export const LAUNCHDARKLY_FLAG_KEY_MAP = Object.freeze({
    // LD dashboard key includes an extra space before "settings".
    [FEATURE_FLAG_KEYS.CAD_AVL_SETTINGS]: 'cad-avl- settings',
    [FEATURE_FLAG_KEYS.UI_EARLY_ACCESS_INDICATOR]: 'ui-early-access-indicator',
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE]: 'enable-under-maintenance',
    [FEATURE_FLAG_KEYS.ENABLE_REMOVE_AGENCY_USER]: 'enable-remove-agency-user',
});

/**
 * Fallback defaults when LaunchDarkly is unavailable or omits a flag.
 * Feature rollout is controlled in LaunchDarkly — not by environment.
 */
export const getEnvFeatureFlagDefaults = () => ({
    [FEATURE_FLAG_KEYS.CAD_AVL_SETTINGS]: false,
    [FEATURE_FLAG_KEYS.UI_EARLY_ACCESS_INDICATOR]: false,
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE]: false,
    [FEATURE_FLAG_KEYS.ENABLE_REMOVE_AGENCY_USER]: false,
});
